// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"615b627f","159":"8ed2cad4","206":"dfca1afe","322":"615b627f","390":"20f41965","487":"94fe147d","557":"6f91fe40","709":"53a3eee2","825":"615b627f","833":"615b627f","897":"1a3ad772"}[chunkId] + ".chunk.css";
};